module.exports = __webpack_public_path__ + "img/dongxiaopan.0e220465.png";